import Plugin from 'src/plugin-system/plugin.class';
import anime from 'animejs/lib/anime.es.js';

export default class ThermoOelAnimationPlugin extends Plugin {

    init() {
        this._registerEvents();
    }

    _registerEvents() {

        var that = this;

        if ("IntersectionObserver" in window) {

            let kreislaufObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(function(entry) {
                  if (entry.isIntersecting) {
                    that._registerAnimation();
                    kreislaufObserver.unobserve(entry.target);
                  }
                });
            });

            kreislaufObserver.observe(document.querySelector('.thermo-oel-animation-widget__kreislauf'));

        } else {

            window.addEventListener('scroll', function() {
                var element = document.querySelector('.thermo-oel-animation-widget__kreislauf');
                var position = element.getBoundingClientRect();
            
                if(position.top >= 0 && position.bottom <= window.innerHeight) {
                    that._registerAnimation();
                }
        
            });
        }
    }

    _registerAnimation() {

        var that = this;

        $('.thermo-oel-animation-widget__kreislauf').addClass('has--started');
        //$('.thermo-oel-animation-widget__kreislauf-wrapper').addClass('is--visible');

        anime({
            targets: '.thermo-oel-animation-widget__circle',
            opacity: 1,
            duration: 1000,
            delay: 4800,
            begin: function(anim) {
                $('.thermo-oel-animation-widget__circle').addClass('is--visible');
            },
            complete: function() {

                //that._startLoop();

                var first = true;

                (function foo() {

                    that._loopElements('.thermo-oel-animation-widget__backblech', '.is--active');

                    if (!first) {
                        that._loopElements('.thermo-oel-animation-widget__einzeln', '.is--active');
                        $('.thermo-oel-animation-widget__backblech.is--static').addClass('not--needed');
                    }

                    first = false;
                    setTimeout(foo, 3000);
                })();

                // var first = true;

                // setInterval(() => {
                //     that._loopElements('.thermo-oel-animation-widget__einzeln', '.is--active');
                //     that._loopElements('.thermo-oel-animation-widget__backblech', '.is--active');
                // }, 3000);
            }
        });

    }

    // _startLoop() {
    //     console.log('do stuff');

    //     setTimeout(this._startLoop, 1000);
    // }

    _loopElements(elementSelector, activeSelector) {

        var elementClass = elementSelector;
        var activeClass = activeSelector.replace(/\./g, "");

        var $next = $(elementClass + ":not(.not--needed)." + activeClass).removeClass(activeClass).next(elementClass);
        if ($next.length) {
            $next.addClass(activeClass); 
        }
        else {
            $(elementClass + ":not(.not--needed):first").addClass(activeClass);
        }
    }

}